module.exports = __webpack_public_path__ + "static/media/R3.97465343.jpg";